const units = ["", "만", "억", "조"];
const smallUnits = ["", "십", "백", "천"];
const numbers = ["", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구"];

function foramtNumberToKorean(num: number) {
  if (num === 0) return "영";

  let result = "";
  let unitIndex = 0;

  while (num > 0) {
    let part = num % 10000;
    let partResult = "";
    let smallUnitIndex = 0;

    while (part > 0) {
      const digit = part % 10;

      if (digit > 0) {
        partResult = numbers[digit] + smallUnits[smallUnitIndex] + partResult;
      }

      part = Math.floor(part / 10);
      smallUnitIndex++;
    }

    if (partResult) {
      result = partResult + units[unitIndex] + result;
    }

    num = Math.floor(num / 10000);
    unitIndex++;
  }

  return result;
}

export default foramtNumberToKorean;
